import React, { useEffect, useState } from 'react';
import * as Chakra from '@chakra-ui/react';
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu';

type CarouselProps = {
    items: React.ReactNode[]
    withDialog?: boolean
} & Chakra.CarouselRootProps

const Component: React.FC<CarouselProps> = ({
    items,
    withDialog,
    ...restProps
}) => {
    const slidesPerPage = restProps.slidesPerPage || 1;

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (withDialog) {
            if (open) document.documentElement.style.overflow = 'hidden';
            else document.documentElement.style.overflow = 'scroll';

            return () => {
                document.documentElement.style.overflow = 'scroll';
            };
        }
        return undefined;
    }, [open]);

    return (
        <>
            <Chakra.Carousel.Root slideCount={items.length} maxW="100%" mx="auto" {...restProps}>
                <Chakra.Carousel.Control justifyContent="center" gap="4" width="full" position="relative">
                    {items.length > slidesPerPage && (
                        <Chakra.Carousel.PrevTrigger asChild>
                            <Chakra.IconButton size="lg" variant="plain" background="black" color="white" position="absolute" margin="auto 0" left={0} zIndex={5}>
                                <LuArrowLeft />
                            </Chakra.IconButton>
                        </Chakra.Carousel.PrevTrigger>
                    )}

                    <Chakra.Carousel.ItemGroup width="full">
                        {items.map((item, index) => (
                            <Chakra.Carousel.Item index={index} onClick={() => setOpen(true)} cursor={withDialog ? 'pointer' : 'default'}>
                                {item}
                            </Chakra.Carousel.Item>
                        ))}
                    </Chakra.Carousel.ItemGroup>
                    {items.length > slidesPerPage && (
                        <Chakra.Carousel.NextTrigger asChild>
                            <Chakra.IconButton size="lg" variant="plain" background="black" color="white" position="absolute" margin="auto 0" right={0} zIndex={5}>
                                <LuArrowRight />
                            </Chakra.IconButton>
                        </Chakra.Carousel.NextTrigger>
                    )}
                </Chakra.Carousel.Control>
                {items.length > slidesPerPage && (
                    <Chakra.Carousel.Indicators />
                )}
            </Chakra.Carousel.Root>
            {withDialog && (
                <Chakra.Dialog.Root
                    size="cover"
                    open={open}
                    onOpenChange={(e: { open: boolean; }) => setOpen(e.open)}
                >
                    <Chakra.Portal>
                        <Chakra.Dialog.Backdrop />
                        <Chakra.Dialog.Positioner>
                            <Chakra.Dialog.Content bg="transparent" shadow="none" height="fit-content" margin="auto">
                                <Chakra.Dialog.CloseTrigger asChild zIndex={10}>
                                    <Chakra.CloseButton size="lg" color="white" background="black" />
                                </Chakra.Dialog.CloseTrigger>

                                <Chakra.Dialog.Body
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    p={0}
                                >
                                    <Chakra.Carousel.Root slideCount={items.length} w="full" h="full">
                                        <Chakra.Carousel.Control justifyContent="center" gap="4" width="full" position="relative" margin="auto">
                                            {items.length > slidesPerPage && (
                                                <Chakra.Carousel.PrevTrigger asChild>
                                                    <Chakra.IconButton size="lg" variant="plain" background="black" color="white" position="absolute" margin="auto 0" left={0} zIndex={5}>
                                                        <LuArrowLeft />
                                                    </Chakra.IconButton>
                                                </Chakra.Carousel.PrevTrigger>
                                            )}

                                            <Chakra.Carousel.ItemGroup
                                                width="full"
                                                maxHeight="90vh"
                                                overflow="scroll"
                                            >
                                                {items.map((item, index) => (
                                                    <Chakra.Carousel.Item index={index}>
                                                        {item}
                                                    </Chakra.Carousel.Item>
                                                ))}
                                            </Chakra.Carousel.ItemGroup>
                                            {items.length > slidesPerPage && (
                                                <Chakra.Carousel.NextTrigger asChild>
                                                    <Chakra.IconButton size="lg" variant="plain" background="black" color="white" position="absolute" margin="auto 0" right={0} zIndex={5}>
                                                        <LuArrowRight />
                                                    </Chakra.IconButton>
                                                </Chakra.Carousel.NextTrigger>
                                            )}
                                        </Chakra.Carousel.Control>
                                        {items.length > slidesPerPage && (
                                            <Chakra.Carousel.Indicators />
                                        )}
                                    </Chakra.Carousel.Root>
                                </Chakra.Dialog.Body>
                            </Chakra.Dialog.Content>
                        </Chakra.Dialog.Positioner>
                    </Chakra.Portal>
                </Chakra.Dialog.Root>
            )}
        </>
    );
};

export const Carousel = Component;
